import React, { ReactNode } from 'react';
import css from './css.less';
import { Link } from 'react-router-dom';
interface IProps {
  to: string;
  className?: string;
  children: ReactNode;
  onClick?: any;
  disable?: boolean;
}
const CustomLink = (props: IProps) => {
  const { to, className, children, onClick, disable, ...rest } = props;

  return (
    <Link
      onClick={(e) => {
        if (disable) {
          e.preventDefault();
        }
        if (onClick) onClick(e);
      }}
      className={`${css.link} ${className || ''} ${disable ? css.disable : ''}`}
      to={to}
      {...rest}>
      {children}
    </Link>
  );
};
export default CustomLink;
